import { useEventVideoContext } from 'context/EventVideoContext'
import { useEventOnlineGuestCountChangedSubscription } from 'graphql/generated'

function useLiveGuestCount({ eventId }: { eventId: string }) {
  const { event } = useEventVideoContext()
  useEventOnlineGuestCountChangedSubscription({
    variables: { eventId }
  })

  return event.onlineGuestCount || 0
}

export default useLiveGuestCount
